import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import { getPropertType } from 'aurora-utils/utils';

import styles from './styles';

function PropertyBadge(props) {
  const { classes, property, isLease } = props;

  const type = getPropertType(property?.propertyType);

  if (type === 'Unit') {
    return (
      <div className={classes.badgePill}>
        {/* Blocked */}
        {!!property?.unitIsBlocked && (
          <div>
            <div className={classes.danger} />
            <FormattedMessage {...messages.blocked} />
          </div>
        )}

        {/* Mortgaged */}
        {!!property?.unitIsMortgaged && (
          <div>
            <div className={classes.warning} />
            <FormattedMessage {...messages.mortgaged} />
          </div>
        )}

        {/* Leased */}
        {!!property?.isLeased && (
          <div>
            <div className={classes.warning} />
            <FormattedMessage {...messages.Leased} />
          </div>
        )}
        {/* Vacant */}
        {isLease && !property?.unitIsMortgaged && !property?.unitIsBlocked && !property?.isLeased && (
          <div>
            <div className={classes.success} />
            <FormattedMessage {...messages.Vacant} />{' '}
          </div>
        )}
        {!!property?.isOffPlan && (
          <div>
            <div className={classes.info} />
            <FormattedMessage {...messages.off_plan} />{' '}
          </div>
        )}
      </div>
    );
  }

  if (type === 'Land') {
    return (
      <div className={classes.badgePill}>
        {/* Blocked */}
        {!!property?.isBlocked && (
          <div>
            <div className={classes.danger} />
            <FormattedMessage {...messages.blocked} />{' '}
          </div>
        )}

        {/* Mortgaged */}
        {!!property?.isMortgaged && (
          <div>
            <div className={classes.warning} />
            <FormattedMessage {...messages.mortgaged} />
          </div>
        )}

        {!!property?.isOffPlan && (
          <div>
            <div className={classes.info} />
            <FormattedMessage {...messages.off_plan} />
          </div>
        )}
      </div>
    );
  }

  return null;
}

PropertyBadge.propTypes = {
  classes: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  isLease: PropTypes.bool.isRequired,
};

export default withStyles(styles)(PropertyBadge);
